const loadAssets = async (urls) => {
	const API = await window.DDC.APILoader.create();

	return Promise.all(
		urls.map((url) => {
			if (url.endsWith('css')) {
				return API.loadCSS(url);
			}
			return API.loadJS(url);
		})
	);
};

export const loadPhotoSwipe = () => {
	const assets = [
		'/static/v9/media/js/photoswipe/v4.1.3/dist/photoswipe.min.js',
		'/static/v9/media/js/photoswipe/v4.1.3/dist/photoswipe-ui-default.min.js',
		'/static/v9/media/js/photoswipe/v4.1.3/dist/photoswipe.min.css',
		'/static/v9/media/js/photoswipe/v4.1.3/dist/default-skin/default-skin.min.css'
	];

	return loadAssets(assets);
};
